module.exports = __webpack_public_path__ + "static/img/aijsmn.9becaae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aijsmn.png
// module id = pWFE
// module chunks = 0